export class OrcaError extends Error {
  code: string = 'ORCA_ERROR';

  constructor(message: string) {
    super(message);
  }
}
